export const COLORS = {
  primary: '#007AFF',
};

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3003/api/v1';

export const API_ENDPOINTS = {
  users: {
    session: '/user/session',
    me: '/user/me',
    update: '/user/update',
  },
  auth: {
    signup: '/auth/signup',
    signin: '/auth/signin',
    checkEmailVerification: '/auth/check-email-verification',
    onboardingStatus: '/auth/onboarding/status',
    onboarding: '/auth/onboarding',
    forgotPassword: '/auth/forgot-password',
    logout: '/auth/logout',
  },
  patients: {
    create: '/patients/',
    list: '/patients/',
    update: (id: string) => `/patients/${id}`,
    delete: (id: string) => `/patients/${id}`,
  },
  payers: {
    create: '/payers/',
    list: '/payers/',
    update: (id: string) => `/payers/${id}`,
    delete: (id: string) => `/payers/${id}`,
  },
  claims: {
    create: '/claims/',
    list: '/claims/',
    detail: (id: string) => `/claims/${id}`,
    update: (id: string) => `/claims/${id}`,
    delete: (id: string) => `/claims/${id}`,
    updateStatus: (id: string) => `/claims/${id}/status`,
    bulkUpload: '/upload-claims',
    bulkUploadExample: '/upload-claims/example',
  },
  twilio: {
    aiCallingStatus: '/twilio/ai-calling-status',
    toggleAiCalling: '/twilio/ai-calling',
  },
  calls: {
    list: '/calls/',
    manual: '/calls/manual',
  },
  dashboard: {
    overview: '/dashboard/overview',
  },
};
